import ScrollRow from "@components/layout/ScrollRow";
import genrePattern from "@svg/pattern.png";
import { Link } from "react-router-dom";

export default function GenresSection({ items }) {
  return (
    <section className="home-genres-row" style={{ padding: "28px 52px 48px" }}>
      <div
        style={{
          fontSize: 32,
          fontWeight: 600,
          color: "#fff",
          textTransform: "uppercase",
          marginBottom: 18,
        }}
        className="jost-s"
      >
        Жанры
      </div>

      <ScrollRow cardStyle="347px">
        {items.map((item) => (
          <Link
            key={item.id}
            className="genre-card"
            to={`/catalog?genre=${encodeURIComponent(item.title)}`}
            style={{
              boxSizing: "border-box",
              position: "relative",
              width: 347,
              height: 287,
              overflow: "hidden",
              background: "#070707",
              border: "1px solid rgba(255, 255, 255, 0.05)",
              borderRadius: 12,
              cursor: "pointer",
              flex: "0 0 auto",
              color: "inherit",
              textDecoration: "none",
            }}
          >
            <div
              aria-hidden="true"
              className="genre-card-pattern"
              style={{
                position: "absolute",
                inset: 0,
                zIndex: 0,
                opacity: 0,
                transition: "opacity 350ms ease",
                pointerEvents: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <img
                src={genrePattern}
                alt=""
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  objectPosition: "center",
                  display: "block",
                }}
              />
            </div>

            <h3
              style={{
                position: "absolute",
                width: 180,
                height: 29,
                left: 24,
                top: 28,
                margin: 0,
                fontFamily: "'Jost', sans-serif",
                fontStyle: "normal",
                fontWeight: 500,
                fontSize: 24,
                lineHeight: "120%",
                display: "flex",
                alignItems: "center",
                letterSpacing: "-0.04em",
                color: "#FFFFFF",
                zIndex: 5,
              }}
            >
              {item.title}
            </h3>

            <div
              style={{
                position: "absolute",
                width: 347,
                height: 199,
                left: 0,
                top: 88,
                overflow: "hidden",
                zIndex: 1,
              }}
            >
              <img
                src={item.image}
                alt=""
                aria-hidden="true"
                style={{
                  position: "absolute",
                  width: "auto",
                  height: "auto",
                  maxWidth: "none",
                  left: 0,
                  bottom: 0,
                  pointerEvents: "none",
                  userSelect: "none",
                }}
              />
            </div>

            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                width: 287,
                height: 69,
                left: 0,
                top: 0,
                background: "linear-gradient(180deg, rgba(7, 7, 7, 0) 0%, #070707 100%)",
                transform: "rotate(90deg)",
                transformOrigin: "top left",
                pointerEvents: "none",
                zIndex: 3,
              }}
            />

            <div
              aria-hidden="true"
              style={{
                position: "absolute",
                width: 287,
                height: 69,
                left: 278,
                top: 0,
                background: "linear-gradient(180deg, rgba(7, 7, 7, 0) 0%, #070707 100%)",
                transform: "matrix(0, 1, 1, 0, 0, 0)",
                transformOrigin: "top left",
                pointerEvents: "none",
                zIndex: 3,
              }}
            />

          </Link>
        ))}
      </ScrollRow>

      <style>{`
        .genre-card:hover .genre-card-pattern {
          opacity: 1 !important;
        }
      `}</style>
    </section>
  );
}
